// 🔹 HTTP Client
import axiosInstance from "../../helpers/axios";

// 🔹 Dispatch Helpers
import {
  catchHandler,
  dispatchLoading,
  elseHandler,
  dispatchToast,
} from "../../helpers/dispatch";

// 🔹 Encryption Utilities
import {
  responseDataFormate,
  requestPayloadBodyFormate,
} from "../../helpers/bycrypt";

export const GetStockList =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStocks", true);

    axiosInstance
      .get("/stock-manager/stock", {
        params: { ...params, order: "order | desc" },
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr = result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_STOCK_DATA",
            payload: {
              data: dataArr,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === limit);
          }
        } else {
          elseHandler(dispatch, "getStocks", result);
        }

        dispatchLoading(dispatch, "getStocks", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStocks")(err);
      });
  };

export const GetStockProcessTypes =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStockProcessTypes", true);

    axiosInstance
      .get("/stock-manager/stock/process-type", {
        params,
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr = result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_STOCK_PROCESS_TYPES_DATA",
            payload: {
              data: dataArr,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === limit);
          }
        } else {
          elseHandler(dispatch, "getStockProcessTypes", result);
        }

        dispatchLoading(dispatch, "getStockProcessTypes", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStockProcessTypes")(err);
      });
  };

export const GetDepartmentList =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDepartments", true);

    axiosInstance
      .get("/departments", {
        params,
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr =
            result?.data?.departments ||
            result?.data?.data ||
            result?.data ||
            [];
          dispatch({
            type: "GET_DEPARTMENTS_DATA",
            payload: {
              data: dataArr,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === limit);
          }
        } else {
          elseHandler(dispatch, "getDepartments", result);
        }

        dispatchLoading(dispatch, "getDepartments", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDepartments")(err);
      });
  };

export const GetMachineList =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getMachines", true);

    axiosInstance
      .get("/machines", {
        params,
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr =
            result?.data?.machines || result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_MACHINES_DATA",
            payload: {
              data: dataArr,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === limit);
          }
        } else {
          elseHandler(dispatch, "getMachines", result);
        }

        dispatchLoading(dispatch, "getMachines", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getMachines")(err);
      });
  };

export const CreateStockProcessAPI =
  (payload: any, onSuccess?: (data: any) => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createStockProcess", true);

    axiosInstance
      .post("/stock-manager/stock/process", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Created successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "createStockProcess", result);
          if (onError) onError();
        }

        dispatchLoading(dispatch, "createStockProcess", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createStockProcess")(err);
        if (onError) onError();
      });
  };

export const UpdateStockProcessAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateStockProcess", true);

    axiosInstance
      .put("/stock-manager/stock/process", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Updated successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "updateStockProcess", result);
        }

        dispatchLoading(dispatch, "updateStockProcess", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateStockProcess")(err);
      });
  };

export const GetStockProcessByIdAPI =
  (id: string, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStockProcessById", true);

    axiosInstance
      .get(`/stock-manager/stock/process`, { params: { id } })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const itemArray = result?.data?.data || result?.data;
          const item = Array.isArray(itemArray)
            ? itemArray[0]
            : itemArray || {};
          if (onSuccess) onSuccess(item);
        } else {
          elseHandler(dispatch, "getStockProcessById", result);
        }
        dispatchLoading(dispatch, "getStockProcessById", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStockProcessById")(err);
      });
  };

export const GetStockProcessesAPI =
  (params?: Record<string, any>, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStockProcesses", true);

    axiosInstance
      .get("/stock-manager/stock/process", {
        params: { ...params, order: params?.order || "order | desc" },
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr = result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_STOCK_PROCESSES_DATA",
            payload: {
              data: dataArr,
              count:
                result?.data?.totalDocs ||
                result?.data?.count ||
                dataArr.length,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === (params?.limit || 10));
          }
        } else {
          elseHandler(dispatch, "getStockProcesses", result);
        }

        dispatchLoading(dispatch, "getStockProcesses", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStockProcesses")(err);
      });
  };

export const DeleteStockProcessAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteStockProcess", true);

    axiosInstance
      .delete("/stock-manager/stock/process", {
        data: payload,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Deleted successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "deleteStockProcess", result);
        }

        dispatchLoading(dispatch, "deleteStockProcess", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteStockProcess")(err);
      });
  };

export const CreateStockComponentAPI =
  (payload: any, onSuccess?: (data: any) => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createStockComponent", true);

    axiosInstance
      .post("/stock-manager/stock/components", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Created successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "createStockComponent", result);
          if (onError) onError();
        }

        dispatchLoading(dispatch, "createStockComponent", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createStockComponent")(err);
        if (onError) onError();
      });
  };

export const UpdateStockComponentAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateStockComponent", true);

    axiosInstance
      .put("/stock-manager/stock/components", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Updated successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "updateStockComponent", result);
        }

        dispatchLoading(dispatch, "updateStockComponent", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateStockComponent")(err);
      });
  };

export const GetStockComponentByIdAPI =
  (id: string, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStockComponentById", true);

    axiosInstance
      .get(`/stock-manager/stock/components/details`, { params: { id } })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const itemArray = result?.data?.data || result?.data;
          const item = Array.isArray(itemArray)
            ? itemArray[0]
            : itemArray || {};
          if (onSuccess) onSuccess(item);
        } else {
          elseHandler(dispatch, "getStockComponentById", result);
        }

        dispatchLoading(dispatch, "getStockComponentById", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStockComponentById")(err);
      });
  };

export const GetStockComponentsAPI =
  (params?: Record<string, any>, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getStockComponents", true);

    axiosInstance
      .get("/stock-manager/stock/components", {
        params: { ...params, order: params?.order || "order | desc" },
        withCredentials: false,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          const dataArr = result?.data?.data || result?.data || [];
          dispatch({
            type: "GET_STOCK_COMPONENTS_DATA",
            payload: {
              data: dataArr,
              count:
                result?.data?.totalDocs ||
                result?.data?.count ||
                dataArr.length,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(dataArr.length === (params?.limit || 10));
          }
        } else {
          elseHandler(dispatch, "getStockComponents", result);
        }

        dispatchLoading(dispatch, "getStockComponents", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getStockComponents")(err);
      });
  };

export const DeleteStockComponentAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteStockComponent", true);

    axiosInstance
      .delete("/stock-manager/stock/components", {
        data: payload,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Deleted successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "deleteStockComponent", result);
        }

        dispatchLoading(dispatch, "deleteStockComponent", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteStockComponent")(err);
      });
  };

export const CreateStockPartAPI =
  (payload: any, onSuccess?: (data?: any) => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createPart", true);

    axiosInstance
      .post("/stock-manager/stock/parts", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Created successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "createPart", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "createPart", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createPart")(err);
        if (onError) onError();
      });
  };

export const UpdateStockPartAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updatePart", true);

    axiosInstance
      .put("/stock-manager/stock/parts", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Updated successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "updatePart", result);
        }
        dispatchLoading(dispatch, "updatePart", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updatePart")(err);
      });
  };

export const GetStockPartByIdAPI =
  (id: string, cb?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPartById", true);

    axiosInstance
      .get(`/stock-manager/stock/parts/details?id=${id}`)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          if (cb) cb(result?.data);
        } else {
          elseHandler(dispatch, "getPartById", result);
        }
        dispatchLoading(dispatch, "getPartById", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPartById")(err);
      });
  };

export const GetStockPartsAPI =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getParts", true);

    axiosInstance
      .get("/stock-manager/stock/parts", {
        params: {
          ...params,
          limit: limit || 25,
          order: params?.order || "order | desc",
        },
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_STOCK_PARTS_DATA",
            payload: {
              data: result?.data?.data || [],
              count: result?.data?.count || 0,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length === limit);
          }
        } else {
          elseHandler(dispatch, "getParts", result);
        }
        dispatchLoading(dispatch, "getParts", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getParts")(err);
      });
  };

export const DeleteStockPartAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deletePart", true);

    axiosInstance
      .delete("/stock-manager/stock/parts", {
        data: payload,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Deleted successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "deletePart", result);
        }
        dispatchLoading(dispatch, "deletePart", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deletePart")(err);
      });
  };

export const GetBOMListAPI =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getBOMs", true);

    axiosInstance
      .get("/bom", {
        params: {
          ...params,
          limit: limit || 25,
          order: params?.order || "order | desc",
        },
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_BOM_DATA",
            payload: {
              data: result?.data?.data || [],
              count: result?.data?.count || result?.data?.totalDocs || 0,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length === limit);
          }
        } else {
          elseHandler(dispatch, "getBOMs", result);
        }
        dispatchLoading(dispatch, "getBOMs", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getBOMs")(err);
      });
  };

export const CreateBOMAPI =
  (payload: any, onSuccess?: (data?: any) => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "createBOM", true);

    axiosInstance
      .post("/bom", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Created successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "createBOM", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "createBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "createBOM")(err);
        if (onError) onError();
      });
  };

export const UpdateBOMAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateBOM", true);

    axiosInstance
      .put("/bom", payload)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Updated successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "updateBOM", result);
        }
        dispatchLoading(dispatch, "updateBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateBOM")(err);
      });
  };

export const GetBOMByIdAPI =
  (id: string, cb?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getBOMById", true);

    axiosInstance
      .get(`/bom/details?id=${id}`)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          if (cb) cb(result?.data);
        } else {
          elseHandler(dispatch, "getBOMById", result);
        }
        dispatchLoading(dispatch, "getBOMById", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getBOMById")(err);
      });
  };

export const DeleteBOMAPI =
  (payload: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteBOM", true);

    axiosInstance
      .delete("/bom", {
        data: payload,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Deleted successfully",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "deleteBOM", result);
        }
        dispatchLoading(dispatch, "deleteBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteBOM")(err);
      });
  };

export const GetProductListAPI =
  (params?: Record<string, any>, limit?: number, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProducts", true);

    axiosInstance
      .get("/products", {
        params: { ...params, limit: limit || 25 },
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_PRODUCT_LIST_DATA",
            payload: {
              data: result?.data?.products || result?.data?.data || [],
              count: result?.data?.total || result?.data?.count || 0,
              page: params?.page || 1,
            },
          });
          if (setHasMore) {
            setHasMore(
              (result?.data?.products || result?.data?.data || []).length ===
                limit,
            );
          }
        } else {
          elseHandler(dispatch, "getProducts", result);
        }
        dispatchLoading(dispatch, "getProducts", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProducts")(err);
      });
  };

export const ReorderStockProcessAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderStockProcess", true);

    const formattedPayload = requestPayloadBodyFormate(payload);
    axiosInstance
      .put("/stock-manager/stock/process/reorder", formattedPayload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Reordered successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "reorderStockProcess", result);
        }

        dispatchLoading(dispatch, "reorderStockProcess", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderStockProcess")(err);
      });
  };

export const ReorderStockComponentAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderStockComponent", true);

    const formattedPayload = requestPayloadBodyFormate(payload);
    axiosInstance
      .put("/stock-manager/stock/components/reorder", formattedPayload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Reordered successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "reorderStockComponent", result);
        }

        dispatchLoading(dispatch, "reorderStockComponent", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderStockComponent")(err);
      });
  };

export const ReorderStockPartAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderStockPart", true);

    const formattedPayload = requestPayloadBodyFormate(payload);
    axiosInstance
      .put("/stock-manager/stock/parts/reorder", formattedPayload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Reordered successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "reorderStockPart", result);
        }

        dispatchLoading(dispatch, "reorderStockPart", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderStockPart")(err);
      });
  };

export const ReorderBOMAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderBOM", true);

    const formattedPayload = requestPayloadBodyFormate(payload);
    axiosInstance
      .put("/bom/reorder", formattedPayload)
      .then((response) => {
        const result = responseDataFormate(response?.data);

        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Reordered successfully",
          );
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "reorderBOM", result);
        }

        dispatchLoading(dispatch, "reorderBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderBOM")(err);
      });
  };

export const GetBOMPartsAndComponentsAPI =
  (params: Record<string, any>, onSuccess?: (data: any) => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getBOMPartsAndComponents", true);

    axiosInstance
      .get("/bom/parts-and-component", { params })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data);
        } else {
          elseHandler(dispatch, "getBOMPartsAndComponents", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "getBOMPartsAndComponents", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getBOMPartsAndComponents")(err);
        if (onError) onError();
      });
  };

export const ExportBOMAPI =
  (id: string, onSuccess?: () => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "exportBOM", true);

    axiosInstance
      .get(`/bom/${id}/export`)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Export queued. You will receive an email when it is ready.",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "exportBOM", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "exportBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "exportBOM")(err);
        if (onError) onError();
      });
  };

export const RegenerateBOMAPI =
  (id: string, onSuccess?: () => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "regenerateBOM", true);

    axiosInstance
      .post(`/bom/${id}/regenerate`)
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "BOM regeneration has been scheduled successfully.",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "regenerateBOM", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "regenerateBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "regenerateBOM")(err);
        if (onError) onError();
      });
  };

export const ImportBOMAPI =
  (id: string, file: File, onSuccess?: () => void, onError?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "importBOM", true);

    const formData = new FormData();
    formData.append("file", file);

    axiosInstance
      .post(`/bom/${id}/import`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "BOM import queued. You will be notified when complete.",
          );
          if (onSuccess) onSuccess();
        } else {
          elseHandler(dispatch, "importBOM", result);
          if (onError) onError();
        }
        dispatchLoading(dispatch, "importBOM", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "importBOM")(err);
        if (onError) onError();
      });
  };
